import { Col, Row } from "react-bootstrap"
import { ExclamationOctagonFill } from "react-bootstrap-icons"

const WarningBanner = ({ show, text } : { show: boolean, text: string }) => {
    if (!show) return null
  return (
    <div className="d-flex justify-content-center text-center m-4 bg-danger text-white rounded p-2">
        <Row>
            <Col xs={12} xl="auto"><ExclamationOctagonFill size={35} /></Col>
            <Col xs={12} xl="auto" className="d-flex align-items-center"><h5 className="mb-0 fw-bold">{text}</h5></Col>
        </Row>
    </div>
  )
}

export default WarningBanner
